import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Tabs from '../Tabs';
import Tab from '../Tab';
import VHSCarousel, { IVHSCarouselProps } from '../VHSCarousel';
export interface IVHSCoursesProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Text
	 */
	text?: string;
	/**
	 * Carousels
	 */
	carousels?: IVHSCarouselProps[];
}

/**
 * Courses
 * @block
 * @icon slides
 */
const VHSCourses: React.FC<IVHSCoursesProps> = ({
	heading,
	text,
	carousels = [],
	className,
	classNames = [],
}) => {
	return (
		<div className={className || cn('vhs-courses', ...classNames)}>
			<div className="vhs-courses__container">
				{heading && <h2 className="vhs-courses__heading">{heading}</h2>}
				{text && <p className="vhs-courses__text">{text}</p>}
				{carousels  && carousels.length > 0 &&
					<div className="vhs-courses__wrapper">
						<Tabs className="vhs-tabs">
							{carousels.map(( carousel, index) => (
								<Tab
									title={carousel.heading}
									key={index}
								>
									<VHSCarousel
										{...carousel}
									/>
								</Tab>
							))}
						</Tabs>
					</div>
				}
			</div>
		</div>
	);
};

export default VHSCourses;
